import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const TOKEN_KEY = "acumen_admin_token";

export const api = axios.create({
    baseURL: API,
    headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use((config) => {
    const token = localStorage.getItem(TOKEN_KEY);
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
});

api.interceptors.response.use(
    (r) => r,
    (err) => {
        // on 401 for admin routes, clear token so UI redirects to login
        if (
            err?.response?.status === 401 &&
            err.config?.url?.includes("/admin/")
        ) {
            localStorage.removeItem(TOKEN_KEY);
        }
        return Promise.reject(err);
    }
);

// Public
export const createLead = (p) => api.post("/leads", p).then((r) => r.data);
export const createConsultation = (p) =>
    api.post("/consultations", p).then((r) => r.data);
export const newsletterSignup = (email) =>
    api.post("/newsletter", { email }).then((r) => r.data);
export const mortgageCalc = (p) =>
    api.post("/tools/mortgage-calc", p).then((r) => r.data);
export const sendChatMessage = (p) => api.post("/chat", p).then((r) => r.data);
export const aiChat = (session_id, message) =>
    api.post("/chat/ai", { session_id, message }).then((r) => r.data);
export const getPublicSettings = () =>
    api.get("/public/settings").then((r) => r.data);
export const getMortgageNews = () =>
    api.get("/news/mortgage").then((r) => r.data);

// Fire-and-forget visitor CTA tracking. Failures are silently ignored so a
// blocked beacon never disrupts the click-through to WhatsApp / call / etc.
export const logIntent = (channel, page) => {
    try {
        api.post("/intents", { channel, page: page || (typeof window !== "undefined" ? window.location.pathname : "") })
            .catch(() => {});
    } catch (_) {
        /* noop */
    }
};

// Auth
export const adminLogin = (username, password) =>
    api.post("/auth/login", { username, password }).then((r) => r.data);
export const authMe = () => api.get("/auth/me").then((r) => r.data);

// Admin
export const adminGetSettings = () =>
    api.get("/admin/settings").then((r) => r.data);
export const adminSaveSettings = (s) =>
    api.put("/admin/settings", s).then((r) => r.data);
export const adminListLeads = (params = {}) =>
    api.get("/admin/leads", { params }).then((r) => r.data);
export const adminUpdateLead = (id, data) =>
    api.patch(`/admin/leads/${id}`, data).then((r) => r.data);
export const adminDeleteLead = (id) =>
    api.delete(`/admin/leads/${id}`).then((r) => r.data);
export const adminListConsultations = (params = {}) =>
    api.get("/admin/consultations", { params }).then((r) => r.data);
export const adminUpdateConsultation = (id, data) =>
    api.patch(`/admin/consultations/${id}`, data).then((r) => r.data);
export const adminAnalytics = (days = 30) =>
    api.get("/admin/analytics", { params: { days } }).then((r) => r.data);
export const adminTestTelegram = () =>
    api.post("/admin/telegram/test").then((r) => r.data);
export const adminGetTelegramRecipients = () =>
    api.get("/admin/telegram/recipients").then((r) => r.data);
export const adminSaveTelegramRecipients = (chat_ids) =>
    api.put("/admin/telegram/recipients", { chat_ids }).then((r) => r.data);
export const adminDiscoverTelegram = () =>
    api.post("/admin/telegram/discover").then((r) => r.data);
